export default __webpack_public_path__ + "static/media/(15).fce422b5.jpg";